import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import defaultProfile from '../../../assets/Default_pfp.svg.png';
import close from '../../../assets/close.png';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
// import { Parser } from "json2csv";
import Papa from 'papaparse';
import { FaDownload } from "react-icons/fa";


const ActiveUsers = () => {

    const [activeUsersList, setActiveUsersList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState("");
    const [showExitModal, setShowExitModal] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [exitDate, setExitDate] = useState("");
    const token = localStorage.getItem('token');
    const navigate = useNavigate();
    
    const buttonStyle = {
        backgroundColor: 'green',
        color: 'white',
        height: '30px', // Adjust the height as needed
        padding: '0 15px', // Adjust padding for a more compact look
        fontSize: '14px', // Adjust font size if needed
        borderRadius: '5px', // Optional: Adjust border radius
      };

    const exitButtonStyle = {
        backgroundColor: 'red',
        color: 'white',
        height: '30px',
        padding: '0 15px',
        fontSize: '14px',
        borderRadius: '5px',
        marginRight: '5px'
    };

    const downloadCSV = () => {

        const selectedFields = filteredList.map(employee => ({
            // Replace 'name', 'age', 'position', etc., with the fields you want
            EmployeeId : employee.hired.employeeId,
            name: employee.full_Name,
            Father_Name : employee.care_of,
            Contact : employee.contact,
            Aadhar_No : employee.aadhar_number,
            DOB : employee.dob,
            Gender : employee.gender,
            Email : employee.email,
            Country : employee.country,
            District : employee.dist,
            House : employee.house,
            Landmark : employee.landmark,
            Loc : employee.loc,
            Post : employee.po,
            State : employee.state,
            Street : employee.street,
            SubDistrict : employee.subdist,
            Zip : employee.zip,
            pan_name : employee.pan_name,
            pan_number : employee.pan_number,
            account_name : employee.account_name,
            account_number : employee.account_number,
            Ifsc : employee.account_ifsc,
            date_of_joining : employee.date_of_joining,
            Basic : employee.basic,
            DA : employee.da,
            HRA : employee.hra,
            other_allowance : employee.other_allowance,
            leave_with_wages : employee.leave_with_wages,
            uan_number : employee.uan_number,
            epf_number : employee.epf_number,
            esi_number : employee.esi_number,
            KYC : employee.kyc
        }));

        // Convert the employee data to CSV format
        const csv = Papa.unparse(selectedFields);
    
        // Create a downloadable link for the CSV file
        const blob = new Blob([csv], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "employee_list.csv"; // Name of the CSV file
        a.click(); // Trigger the download
    };

    const handleExitClick = (employee) => {
        setSelectedEmployee(employee);
        setShowExitModal(true);
        setExitDate("");
    };

    const handleCloseModal = () => {
        setShowExitModal(false);
        setSelectedEmployee(null);
        setExitDate("");
    };

    const handleExitSubmit = async () => {
        if (!selectedEmployee || !exitDate) {
            toast.error("Please select an exit date");
            return;
        }

        try {
            console.log("Processing exit for employee:", selectedEmployee._id, "Exit date:", exitDate);
            
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/establishment/exit-employee`,
                {
                    employeeId: selectedEmployee._id,
                    exitDate: exitDate
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            console.log("Exit response:", response.data);

            if (response.data.success) {
                toast.success("Employee exit processed successfully");
                handleCloseModal();
                // Refresh the active users list
                fetchingHired(selectedClient);
            } else {
                toast.error(response.data.message || "Failed to process employee exit");
            }
        } catch (error) {
            console.error("Error processing employee exit:", error);
            console.error("Error response:", error.response?.data);
            
            const errorMessage = error.response?.data?.message || 
                                error.message || 
                                "Failed to process employee exit";
            toast.error(errorMessage);
        }
    };


    const fetchClients = async () => {
        try{
            const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/establishment/clientlist`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            setClients(res.data?.clients || res.data || []);
        }catch(err){
            console.error(err);
        }
    }

    const fetchingHired = async(clientId="") => {
        try{
            setLoading(true);
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/establishment/active-users`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    clientId: clientId || undefined
                }
            })
            .then((res) => {
                setActiveUsersList(res.data.activeUsers);
                setFilteredList(res.data.activeUsers);
                setLoading(false);
                // console.log(res);
            })
        }
        catch(e){
            toast.error(e.response.data.message);
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchClients();
        fetchingHired();
    }, []);

    useEffect(() => {
        // refetch with filter
        fetchingHired(selectedClient);
    }, [selectedClient]);

    if(loading){
        return (<div>Loading...</div>)
    }

    let changeHandle = (e) => {
        let query = e.target.value.toLowerCase();
  
        const filteredData = activeUsersList && activeUsersList.length? activeUsersList.filter((user) => 
            (user.employeeId?.toString() || "").toLowerCase().includes(query) ||
            (user.full_Name || "").toLowerCase().includes(query) ||
            (user.contact || "").toLowerCase().includes(query)
        ) : [];
        setFilteredList(filteredData);
    }

    function toggleShow () {
        var el = document.getElementById("box");
        el.classList.toggle("show");
    }
    


    let openEnquiry = () => {
        const enquiry_pop_up = document.querySelector(".enquiry-section");
        enquiry_pop_up.style.scale = 1;
      }
      
      let closeEnquiry = () => {
        const enquiry_pop_up = document.querySelector(".enquiry-section");
        enquiry_pop_up.style.scale = 0;
      };

    


  return (
    <div className='supervisor_hire position-relative w-full'>
        <div className='w-full d-flex justify-content-center mt-5'>
            <h1 className='fs-2 text-center' style={{color : 'green'}}>Active Employees</h1>
        </div>
        <div className='ragister_div' style={{paddingTop : '0px', alignItems : 'center', cursor: 'pointer'}}>
            <div className='search_container mb-5'>
                  <input type="text" id="box" placeholder="Search by ID, Name, or Mobile..." class="search__box" onChange={changeHandle} />
                  <i class="fas fa-search search__icon" id="icon" onClick={toggleShow}></i>
            </div>
            <div className="ms-3">
                <select className="form-select" value={selectedClient} onChange={(e)=>setSelectedClient(e.target.value)}>
                    <option value="">All Clients</option>
                    {clients.map((c)=>(
                        <option key={c._id || c.name} value={c._id}>{c.name}</option>
                    ))}
                </select>
            </div>
            <FaDownload onClick={downloadCSV} />
            {/* <Button className='mt-2' onClick={postHiringButtonHandler} varient='primary'>Post Hiring</Button> */}
        </div>
        <div>
            <ul className='list_box px-5' style={{padding : '0px'}}>
                {
                    filteredList?.map((user) => {
                        return ( 
                            <li className='list'>
                                <img className='' src={defaultProfile} alt='' />
                                <div className='w-full'>
                                    <div className='list_content w-full' style={{justifyContent : 'space-between'}}>
                                        <div className='list-left'>
                                            <p>{user.employeeId ? `CMPL${user.employeeId}` : "N/A"}</p>
                                        </div>
                                        <div className='list-middle'>
                                            <p>{user.full_Name}</p>
                                        </div>
                                        <div className='list-middle'>
                                            <p>{user.contact}</p>
                                        </div>
                                        <div className='list-middle'>
                                            <p>{user.aadhar_number || "N/A"}</p>
                                        </div>
                                        <div className='list-right'>
                                            <button class="btn custom-btn" onClick={() => {navigate('/establisment_dashboard/employee-detail', { state : { employeeId : user._id } })}} style={buttonStyle}>View</button>
                                            <button class="btn custom-btn" onClick={() => handleExitClick(user)} style={exitButtonStyle}>Exit</button>
                                        </div>
                                    </div>
                                </div>  
                            </li>
                        )
                    })
                }
            </ul>
        </div>

        {/* Exit Modal */}
        {showExitModal && (
            <div className="modal-overlay" style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000
            }}>
                <div className="modal-content" style={{
                    backgroundColor: 'white',
                    padding: '30px',
                    borderRadius: '10px',
                    minWidth: '400px',
                    maxWidth: '500px'
                }}>
                    <h3 style={{ marginBottom: '20px', color: '#333' }}>
                        Process Employee Exit
                    </h3>
                    {selectedEmployee && (
                        <div style={{ marginBottom: '20px' }}>
                            <p><strong>Employee:</strong> {selectedEmployee.full_Name}</p>
                            <p><strong>Employee ID:</strong> {selectedEmployee.employeeId ? `CMPL${selectedEmployee.employeeId}` : "N/A"}</p>
                        </div>
                    )}
                    <div style={{ marginBottom: '20px' }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                            Exit Date:
                        </label>
                        <input
                            type="date"
                            value={exitDate}
                            onChange={(e) => setExitDate(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '8px',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                fontSize: '14px'
                            }}
                            required
                        />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                        <button
                            onClick={handleCloseModal}
                            style={{
                                padding: '8px 16px',
                                border: '1px solid #ccc',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleExitSubmit}
                            style={{
                                padding: '8px 16px',
                                backgroundColor: '#dc3545',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                        >
                            Process Exit
                        </button>
                    </div>
                </div>
            </div>
        )}
    </div>
  )
}

export default ActiveUsers;
